__turbopack_context__.v({
  "feature": "loginModal-module-scss-module__ffFb0G__feature",
  "features": "loginModal-module-scss-module__ffFb0G__features",
  "footer": "loginModal-module-scss-module__ffFb0G__footer",
  "loginBtn": "loginModal-module-scss-module__ffFb0G__loginBtn",
  "loginModal": "loginModal-module-scss-module__ffFb0G__loginModal",
  "logo": "loginModal-module-scss-module__ffFb0G__logo",
  "registerBtn": "loginModal-module-scss-module__ffFb0G__registerBtn",
  "subTitle": "loginModal-module-scss-module__ffFb0G__subTitle",
  "title": "loginModal-module-scss-module__ffFb0G__title",
});
